import React from "react";
import {
  Button,
  CollapsibleWrapper,
  FormFieldSet,
  PageTitle,
  StatusTags,
  TableAdv,
} from "../../../../components";
import { dateFormator, formatNumber, mapTableRows } from "../../../../utils";
import { EmployeeStatus, Gender } from "../../../../assets/data/enumData";

const CollapsibleWrapperList = () => {
  const rows = Array.from({ length: 400 }, (_, i) => ({
    id: i + 100,
    fullName: {
      firstName: `User ${i + 1}`,
      middleName: `Middle Name ${i + 1}`, // Add middleName to the row data for demonstration purposes
      lastName: `Last Name ${i + 1}`,
    },
    profilePhotoUrl: "",
    username: `user${i + 1}`,
    password: `password${i + 1}`,
    email: `user${i + 1}@example.com`,
    salary: Math.floor(Math.random() * 10000) + 1000,
    joindedDate: new Date(
      Date.now() - Math.floor(Math.random() * 100000000000),
    ).toISOString(), // need like MongoDB stores dates as BSON Date objects
    age: Math.floor(Math.random() * 50) + 18,
    company: `Company ${i + 1}`,
    department: [
      "Engineering",
      "Marketing and sales",
      "Sales",
      "HR",
      "Finance",
    ][Math.floor(Math.random() * 5)],
    status: [1, 2, 3][Math.floor(Math.random() * 3)],
    info: ["", `Some Info for this id ${i + 1}`][Math.floor(Math.random() * 2)],
    countries: [
      "USA",
      "Canada",
      "Australia",
      "India",
      "United Kingdom",
      "Germany",
      "France",
      "Spain",
      "Italy",
      "Brazil",
    ][Math.floor(Math.random() * 10)],
    gender: [1, 2, 3, 4][Math.floor(Math.random() * 4)],

    phone: `+1 (${Math.floor(Math.random() * 1000)}) ${Math.floor(
      Math.random() * 1000,
    )}-${Math.floor(Math.random() * 10000)}`,
    address: `123 Main St, City ${i + 1}, State ${i + 1}, Country ${i + 1}`,
  }));

  const columns = [
    {
      key: "fullName",
      labelKey: "fullName",
      label: "Employee Name",
      render: (row) => {
        return (
          <div className="flex gap-2 items-center">
            {row.fullName.firstName}-{row.fullName.middleName}-
            {row.fullName.lastName}
          </div>
        );
      },
      width: "min-w-80", // Using Tailwind class for width
    },

    {
      key: "joindedDate",
      label: "Joinded Date",
      render: (row) => {
        return (
          <div className="whitespace-nowrap">
            {dateFormator(row.joindedDate)}
          </div>
        );
      },
    },
    {
      key: "email",
      label: "Email Address",
    },
    {
      key: "age",
      label: "Age",
    },
    {
      key: "department",
      label: "Department",
      render: (row) => {
        return <div className="whitespace-nowrap">{row.department}</div>;
      },
    },
    {
      key: "status",
      label: "Status",
      render: (row) => {
        return (
          <div className="whitespace-nowrap">
            <StatusTags
              size="sm"
              tag={
                EmployeeStatus.find((item) => item.value === row.status)?.label
              }
            />
          </div>
        );
      },
      dataType: "enum",
      dataValue: EmployeeStatus,
    },
    {
      key: "countries",
      label: "Countries",
      // No width specified, will use default flex: 1
    },
    {
      key: "gender",
      label: "Gender",
      render: (row) => {
        return (
          <div>
            {Gender.find((g) => g.value === row.gender)?.label || row.gender}
          </div>
        );
      },

      dataType: "enum",
      dataValue: Gender,

      // getCellClass: (row) => {
      //   if (row.gender === "Male" && row.countries === "India") {
      //     return "bg-green-900 text-white ";
      //   } else if (row.gender === "Female") {
      //     return "bg-pink-300 ";
      //   }
      //   return ""; // Default case
      // },
      // hide: true,
    },
    {
      key: "phone",
      label: "Phone",
      render: (row) => {
        return <div className="whitespace-nowrap">{row.phone}</div>;
      },
      // hide: true,
    },
    {
      key: "address",
      label: "Address",
      //width: "w-[350px]",
      render: (row) => {
        return <div className="whitespace-nowrap">{row.address}</div>;
      },
      // hide: true,
    },

    {
      key: "salary",
      label: "Salary",
    },

    {
      key: "",
      label: "Action",
      render: (row) => {
        return (
          <div className="flex gap-2">
            <Button
              type="icon"
              icon={"edit"}
              variant="text"
              size="xs-sm"
              color="info"
              onClick={() => {
                console.log("edit", row);
              }}
            />
            <Button
              type="icon"
              icon={"delete"}
              variant="text"
              size="xs-sm"
              color="danger"
              onClick={() => {
                console.log("delete", row);
              }}
            />
          </div>
        );
      },
    },
  ];
  const mappedRows = mapTableRows(rows, columns);

  const Sidebar = () => {
    return (
      <div className="flex-1 flex flex-col overflow-auto w-96">
        <PageTitle title={"Table Filer"} />
        <div className="grid grid-cols-2 gap-1 gap-x-3 mr-2">
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
          <FormFieldSet title="Check-1" />
        </div>
      </div>
    );
  };

  return (
    <div className="flex-1 flex overflow-hidden">
      <CollapsibleWrapper sidebar={<Sidebar />}>
        <>
          <TableAdv
            columns={columns}
            rows={mappedRows}
            showCheckbox={true}
            showSlNo={true}
            showPages
            tableId={"newTableForTestingCollapsibleWrapper"}
            /////////////////////////////////////////
          />
        </>
      </CollapsibleWrapper>
    </div>
  );
};

export default CollapsibleWrapperList;
